export const status = {
    method: 'POST',
    paths: ['/remoteDiagnostic/gazeboStatus'],
    fields: {
        locationName: {
            type: 'keyString',
            required: true,
        },
        locationId: {
            type: 'mongoId',
        },
        status: {
            type: 'object',
            isFreeform: true,
            required: true,
        },
    },
};
//# sourceMappingURL=remote_diagnostic_status.js.map